export default "__VITE_ASSET__CCSzZL9k__"